"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var RevertSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M5.66068933,7 L8,7 L8,8 L4,8 L4,4 L5,4 L5,6.19671552 C5.99446314,4.81810848 7.3482222,4 9,4 C11.7761424,4 14,6.22385763 14,9 C14,11.7761424 11.7761424,14 9,14 C6.60535937,14 4.57013149,12.2787547 4.10144231,10 L5.12823762,10 C5.57823343,11.7209986 7.15817062,13 9,13 C11.2238576,13 13,11.2238576 13,9 C13,6.77614237 11.2238576,5 9,5 C7.62914079,5 6.49760488,5.7301661 5.66068933,7 Z" })));
};
RevertSmall.displayName = 'RevertSmall';
exports.default = RevertSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=RevertSmall.js.map